import { userRequest } from '../requestMethods';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getTemplateCount = async () => {
  return userRequest.get(`${DOMAIN}/api/template/count`);
};

export const getTemplate = async (role, userId) => {
    return userRequest.get(`${DOMAIN}/api/template?role=${role}&userId=${userId}`);
  };

export const getTemplateBatimentOne = async (id) => {
  return userRequest.get(`${DOMAIN}/api/template/templateBatiment?id_batiment=${id}`);
};

export const getTemplateClientOne = async (id) => {
    return userRequest.get(`${DOMAIN}/api/template/templateClientOne?id_client=${id}`);
  };

export const getTemplate5derniers = async (id, periode, idProvince) => {
    return userRequest.get(`${DOMAIN}/api/template/5derniers?id_client=${id}&periode=${periode}&idProvince=${idProvince}`);
  };

export const getTemplateDeuxMoisPrecedent = async (id, idProvince) => {
    return userRequest.get(`${DOMAIN}/api/template/2mois_precedents?id_client=${id}&idProvince=${idProvince}`);
  };

export const putTemplateStatus = async (id, data) => {
    return userRequest.put(`${DOMAIN}/api/template/statut?id_template=${id}`, {
      status_template : data
    });
  };

export const getTemplateOne = async (id) => {
    return userRequest.get(`${DOMAIN}/api/template/one?id_template=${id}`);
  };

export const postTemplate = async (data, userId) => {
    return userRequest.post(`${DOMAIN}/api/template?userId=${userId}`, data);
  };

export const deletePutTemplate = async (id) => {
    return userRequest.put(`${DOMAIN}/api/template/template_update_delete?id=${id}`);
  };

export const putTemplate = async (id,data) => {
    return userRequest.put(`${DOMAIN}/api/template/template_update?id_template=${id}`, data);
  };

export const getTypeOccupation = async () => {
    return userRequest.get(`${DOMAIN}/api/template/type_occupation`);
  };

export const getObjetFacture = async () => {
    return userRequest.get(`${DOMAIN}/api/template/objet_facture`);
  };

//Déclaration superficie
export const getDeclarationId = async () => {
  return userRequest.get(`${DOMAIN}/api/template/declaration_ID`);
}

export const getDeclarationCount = async () => {
  return userRequest.get(`${DOMAIN}/api/template/declaration_count`);
};

export const getDeclaration = async (data, searchValue, role, userId) => {
    return userRequest.post(`${DOMAIN}/api/template/declaration_superficies?search=${searchValue}&role=${role}&userId=${userId}`, data);
  };

export const getDeclarationClientOneAll= async (idClient, data) => {
    return userRequest.post(`${DOMAIN}/api/template/declaration_superficies_client_OneAll?idClient=${idClient}`, data);
  };

export const getDeclaration5derniers = async () => {
    return userRequest.get(`${DOMAIN}/api/template/declaration_superficies_5derniers`);
  };

export const getDeclarationOne = async (id) => {
    return userRequest.get(`${DOMAIN}/api/template/declaration_superficie/one?id=${id}`);
  };

export const getDeclarationOneClient = async (id, idProvince, periode) => {
    return userRequest.get(`${DOMAIN}/api/template/declaration_superficie/oneClient?id_client=${id}&idProvince=${idProvince}&periode=${periode}`);
  };

export const getDeclarationOneClientV = async (id, data) => {
    return userRequest.post(`${DOMAIN}/api/template/declaration_superficie/oneClientV?id_client=${id}`, data);
  };

export const getDeclarationVille = async (id) => {
    return userRequest.get(`${DOMAIN}/api/template/declaration_superficie/oneVille?id_ville=${id}`);
  };
export const postDeclaration = async (data) => {
    return userRequest.post(`${DOMAIN}/api/template/declaration_superficie`, data);
  };

export const putDeclaration = async (id,data, version) => {
    return userRequest.put(`${DOMAIN}/api/template/declaration_superficie?id_declaration=${id}&version=${version}`, data);
  };

export const putDeclarationTotalEntrep = async (id,data) => {
    return userRequest.put(`${DOMAIN}/api/template/putDeclarationTotalEntrep?id_declaration=${id}`, data);
  };

export const lockDeclaration = async (userId, id ) => {
    return userRequest.post(`${DOMAIN}/api/template/lock_declaration?userId=${userId}&id=${id}`);
  };

export const check_and_unlock = async () => {
    // ✅ Bug #3 compat : backend attend GET (pas POST)
    return userRequest.get(`${DOMAIN}/api/template/check_and_unlock`);
  };

export const DelockDeclaration = async (userId, id) => {
    return userRequest.post(`${DOMAIN}/api/template/delock_declaration?userId=${userId}&id=${id}`);
  };

export const deletePutDeclaration = async (id, userId) => {
    return userRequest.put(`${DOMAIN}/api/template/declaration_superficie_delete?id=${id}`, {user_id:userId});
  };

  //Statut declarations
export const putDeclarationsStatus = async (id, data) => {
    return userRequest.put(`${DOMAIN}/api/template/statut_declaration?id_declarations=${id}`, {
      status_decl : data
    });
  };

  export const putDeclarationsStatusCloture = async (data) => {
    return userRequest.put(`${DOMAIN}/api/template/statut_declaration_cloture`, data);
  };

export const getContrat = async () => {
    return userRequest.get(`${DOMAIN}/api/template/contrat`);
  };

export const getContratOne = async (id) => {
  return userRequest.get(`${DOMAIN}/api/template/contratOne?id_client=${id}`);
};

export const postContrat = async (data) => {
  return userRequest.post(`${DOMAIN}/api/template/contrat`, data);
};

//Type contrat
export const getTypeContrat = async () => {
  return userRequest.get(`${DOMAIN}/api/template/type_contrat`);
};

//Rapport facture
export const getRapportFacture = async (filter) => {
  return userRequest.post(`${DOMAIN}/api/template/rapport_facture`, filter);
};

export const getRapportFactureClientOne = async (id, filter) => {
  return userRequest.post(`${DOMAIN}/api/template/rapport_factureClientOne?id_client=${id}`, filter);
};

//Rapport superficie
export const getRapportSuperficie = async (filter) => {
  return userRequest.post(`${DOMAIN}/api/template/rapport_superficie`, filter);
};

//Rapport complet
export const getRapportComplet = async (filter) => {
  return userRequest.post(`${DOMAIN}/api/template//rapport_complet`, filter);
};

export const getRapportFactureClient = async (filter) => {
  return userRequest.get(`${DOMAIN}/api/template/rapport_facture_client`, filter);
};

export const getRapportFactureVille = async (filter) => {
  return userRequest.post(`${DOMAIN}/api/template/rapport_facture_ville`, filter);
};

export const getRapportFactureExterneEtInterne = async (filter) => {
  return userRequest.post(`${DOMAIN}/api/template/rapport_facture_externeEtInternet`, filter);
};

//Rapport ville
export const getRapportVille = async (filter) => {
  return userRequest.post(`${DOMAIN}/api/template/rapport_ville`,filter);
};

//Rapport Pays
export const getRapportPays = async (filter) => {
  return userRequest.post(`${DOMAIN}/api/template/rapport_pays`,filter);
};

//Rapport Externe et Interne
export const getRapportExterneEtInterne = async (filter) => {
  return userRequest.post(`${DOMAIN}/api/template/rapport_externEtInterne`,filter);
};

//Rapport Externe et Interne Annee
export const getRapportExterneEtInterneAnnee = async (filter) => {
  return userRequest.post(`${DOMAIN}/api/template/rapport_externEtInterneAnnee`,filter);
};

//Rapport Externe et Interne Client
export const getRapportExterneEtInterneClient = async (filter) => {
  return userRequest.post(`${DOMAIN}/api/template/rapport_externEtInterneClient`,filter);
};

//Rapport Manutentation
export const getRapportManutentation = async (filter) => {
  return userRequest.post(`${DOMAIN}/api/template/rapport_manutentation`, filter);
};

//Rapport Entreposage
export const getRapportEntreposage = async (filter) => {
  return userRequest.post(`${DOMAIN}/api/template/rapport_entreposage`, filter);
};

//Rapport Template
export const getRapportTemplate = async (filter) => {
  return userRequest.post(`${DOMAIN}/api/template/rapport_template`, filter);
};

//Rapport Batiment
export const getRapportBatiment = async (filter) => {
  return userRequest.post(`${DOMAIN}/api/template/rapport_batiment`, filter);
};

//Rapport Variation
export const getRapportVariation = async (filter) => {
  return userRequest.post(`${DOMAIN}/api/template/rapport_variation`, filter);
};


//Rapport Variation ville
export const getRapportVariationVille = async (filter) => {
  return userRequest.post(`${DOMAIN}/api/template/rapport_variation_ville`, filter);
};

//Rapport Variation client
export const getRapportVariationClient = async (filter) => {
  return userRequest.post(`${DOMAIN}/api/template/rapport_variation_client`, filter);
};



//Mois & ANNEE
export const getMois = async (annee) => {
  return userRequest.get(`${DOMAIN}/api/template/mois?annee=${annee}`);
};

export const getAnnee = async () => {
  return userRequest.get(`${DOMAIN}/api/template/annee`);
};

//Audit déclaration
export const getAudit_logs_declaration = async () => {
  return userRequest.get(`${DOMAIN}/api/template/audit_logs_declaration`);
};

export const getDeclaration_corbeille = async (id) => {
  return userRequest.get(`${DOMAIN}/api/template/declaration_corbeille`);
};

export const putDeclaration_corbeille = async (id) => {
  return userRequest.put(`${DOMAIN}/api/template/declaration_corbeille?id_declaration=${id}`);
};

export const deleteDeclaration = async (id) => {
  return userRequest.delete(`${DOMAIN}/api/template/declaration_superficie/${id}`);
};